<template>
  <div class="text-center"
       :class="{
         'text-center-body-fail': !isMatch,
       }"
       @drop="onChange"
       @dragenter="dragenter"
       @dragover.prevent>
    <div class="mt-42px">
      <v-icon style="font-size: 45px">insert_drive_file </v-icon>
    </div>
    <div class="mt-14px">
      <input type="file" id="file" ref="import" @change="onChange" hidden>
      <button class="btn" @click="chooseFiles">上傳CSV檔案</button>
    </div>
    <div class="mt-10px">或將檔案拖曳至此</div>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      type: File,
      default: () => ({}),
    },
  },
  data: () => ({
    isDrag: false,
    isMatch: true,
    format: [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'text/csv',
    ],
  }),
  methods: {
    updateStatus() {
      this.$emit('update:currentStep', 1);
      this.$emit('update:currentStatus', 2);
    },
    dragleave(e) {
      e.preventDefault();
      this.isDrag = false;
      this.isMatch = true;
    },
    onChange(e) {
      e.preventDefault();
      const data = e.target.files || e.dataTransfer.files;
      if (!data.length) {
        this.isDrag = false;
        return;
      }
      // console.log(data[0]);
      for (let i = 0; i < data.length; i += 1) {
        if (this.format.indexOf(data[i].type) === -1) {
          this.setFailFileTips();
          return;
        }
      }
      this.handleFileUpload(data[0]);
    },
    dragenter(e) {
      e.preventDefault();
      this.isDrag = true;
    },
    handleFileUpload(data) {
      this.$emit('update:file', data);
      this.updateStatus();
    },
    setFailFileTips() {
      this.isMatch = false;
      setTimeout(() => {
        this.isMatch = true;
        this.isDrag = false;
      }, 1500);
    },
    chooseFiles() {
      this.$refs.import.click();
    },
  },
};
</script>

<style lang="scss">
.text-center {

  &-body {
    height: 216px;
    border: 1px dashed #848fa0;
    text-align: center;
    border-radius: 4px;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #848fa0;
    }

    .btn {
      margin-top: 9px;
    }

    div {
      margin-top: 10px;
    }
  }

  &-body-drag {
    height: 216px;
    text-align: center;
    border-radius: 4px;
    border: 1px dashed #194cc3;
    background-color: #e8efff;
    color: #1e50c0;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #1e50c0;
    }

    div {
      margin-top: 10px;
    }
  }

  &-body-fail {
    height: 216px;
    text-align: center;
    border-radius: 4px;
    border: 1px dashed #f90000;
    background-color: #ffe7e7;
    color: #ff0000;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #ff0000;
    }

    div {
      margin-top: 10px;
    }
  }
}
</style>
